<template>
    <div class="indented margin-top-10">
        <div class="display-flex justify-content-space-between">
            <div @click="handleViewDocument" class="wrap-left">
                <h6><strong>{{ item.name }}</strong></h6>
                <div>({{ nameTypeDocument }})</div>
            </div>
            <div class="wrap-right display-flex justify-content-space-between">
                <button type="button" @click="handleEditDocument"
                    class="btn btn-edit border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                    v-if="isEdit == 1">
                    Sửa bài giảng
                </button>
                <button type="button" @click="handleDeleteDocument"
                    class="btn btn-delete border-rd-20 font-size-16 form-30h display-flex-center justify-content-center line-height-1"
                    v-if="isEdit == 1">
                    Xóa bài giảng
                </button>
            </div>
        </div>
        <slot name="document">
        </slot>
    </div>
</template>
<script>
import { TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK } from './../../../constants/constants_enum'
export default {
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        isEdit: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            isLoading: false,
            TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
            listTypeDocument: [
                { value: TYPE_H5P, text: 'Bài giảng tương tác H5P' },
                { value: TYPE_DOCUMENT, text: 'Dạng tài liệu' },
                { value: TYPE_TEST, text: 'Dạng kiểm tra' },
                { value: FILE_YOUTUBE, text: 'Dạng youtube' },
                { value: FILE_CANVA, text: 'Dạng canva' },
                { value: FILE_LINK, text: 'Dạng nhúng' },
            ]
        }
    },
    computed: {
        nameTypeDocument() {
            for (let i = 0; i < this.listTypeDocument.length; i++) {
                const type = this.listTypeDocument[i];
                if (this.item.typeDocument == type.value) {
                    return type.text
                }
            }
            return ''
        }
    },
    methods: {
        handleEditDocument() {
            this.$emit('handleEditDocument', this.item)
        },
        handleDeleteDocument() {
            this.$emit('handleDeleteDocument', this.item)
        },
        handleViewDocument(){
            this.$emit('handleViewDocument', this.item)
        }
    }
}
</script>
<style lang="scss" scoped>
.btn-delete {
    background-color: red;
    color: white;
    margin-left: 5px;
}

.btn-edit {
    background-color: #7ea8c7;
    color: rgb(70, 69, 69);
    margin-left: 5px;
}

.margin-top-10 {
    margin-top: 10px;
}

.indented {
    margin-left: 20px;
    /* Đặt giá trị thụt cách tùy ý */
}

.justify-content-space-between {
    justify-content: space-between;
}
</style>